// src/words.ts
// EFF Short Wordlist: 1,296 memorable words, safe for spoken room codes.
// Source: eff-short-wordlist.json in project root.
import rawWords from '../eff-short-wordlist.json';

const WORDS: string[] = rawWords as string[];
export const WORD_COUNT = WORDS.length; // 1296

/** Cryptographically random integer in [0, max) */
function randomInt(max: number): number {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  // Rejection sampling to avoid modulo bias
  const limit = Math.floor(0x100000000 / max) * max;
  let val = array[0]!;
  while (val >= limit) {
    crypto.getRandomValues(array);
    val = array[0]!;
  }
  return val % max;
}

/**
 * Generate a random 3-word room code from the EFF short wordlist.
 * Returns all-uppercase, space-separated: e.g. "ACID AGILE ALARM"
 */
export function generateRoomCode(): string {
  return [
    WORDS[randomInt(WORDS.length)],
    WORDS[randomInt(WORDS.length)],
    WORDS[randomInt(WORDS.length)],
  ].join(' ').toUpperCase();
}

/**
 * Normalize and split a room code into lowercase words.
 * Accepts any combination of spaces, hyphens, underscores as separators.
 * Returns an array of lowercase words.
 */
export function parseRoomCode(input: string): string[] {
  return input
    .trim()
    .toLowerCase()
    .split(/[\s\-_]+/)
    .filter(Boolean);
}

/**
 * Check if a single lowercase word is in the EFF wordlist.
 */
export function isValidRoomCode(word: string): boolean {
  return WORDS.includes(word.toLowerCase());
}

/**
 * Validate a full 3-word room code string (any casing, any separator).
 * Returns true only if all 3 words are in the EFF list.
 */
export function validateRoomCode(code: string): boolean {
  const words = parseRoomCode(code);
  if (words.length !== 3) return false;
  return words.every(isValidRoomCode);
}
